// Illustrations of the ideas behind the projects; these are not product screenshots.
export default function ProjectArtwork({ kind }) {
  if (kind === "krishi")
    return (
      <svg
        viewBox="0 0 640 380"
        fill="none"
        role="img"
        aria-label="Concept illustration: a growing plant connects soil, signals, and farming decisions"
      >
        <defs>
          <pattern
            id="krishi-dots"
            width="24"
            height="24"
            patternUnits="userSpaceOnUse"
          >
            <circle cx="2" cy="2" r=".8" fill="#c6d3ab" opacity=".2" />
          </pattern>
        </defs>
        <path fill="url(#krishi-dots)" d="M0 0h640v380H0z" />
        {Array.from({ length: 8 }, (_, i) => (
          <path
            key={i}
            d={`M-40 ${320 + i * 14} Q160 ${150 + i * 17} 340 ${275 + i * 14} T700 ${200 + i * 16}`}
            stroke="#b2c29b"
            opacity=".16"
          />
        ))}
        <path
          d="M320 290V112M320 225C252 225 239 175 250 153c47 3 70 38 70 72ZM320 188c66 0 89-46 76-75-44 5-73 29-76 75Z"
          stroke="#dae2b9"
          strokeWidth="2"
        />
        <path d="m255 160 65 65m70-106-70 69" stroke="#dae2b9" opacity=".5" />
        <circle cx="320" cy="100" r="6" fill="#e5b46e" />
        <path
          d="M300 290h40m-20 0-27 31m27-31 28 31m-28-31v40"
          stroke="#b2c29b"
          strokeWidth="1.5"
        />
        <path
          d="M245 188H140v-35m260 2h96v60"
          stroke="#dae2b9"
          opacity=".5"
          strokeDasharray="3 5"
        />
        <circle cx="140" cy="150" r="3" fill="#e5b46e" />
        <circle cx="496" cy="220" r="3" fill="#e5b46e" />
        <text x="93" y="130" fill="#dae2b9" className="art-mono">
          SOIL → SIGNAL
        </text>
        <text x="444" y="248" fill="#dae2b9" className="art-mono">
          → DECISION
        </text>
        <text x="36" y="48" fill="#dae2b9" className="art-small">
          KRISHI SATHI / कृषि साथी
        </text>
        <text x="476" y="340" fill="#dae2b9" className="art-small">
          GROW WITH DATA.
        </text>
      </svg>
    );
  if (kind === "ismh")
    return (
      <svg
        viewBox="0 0 640 380"
        fill="none"
        role="img"
        aria-label="Concept illustration: messaging channels route through retrieval with human handover"
      >
        <defs>
          <pattern
            id="ismh-grid"
            width="32"
            height="32"
            patternUnits="userSpaceOnUse"
          >
            <path d="M32 0H0v32" stroke="#b5b8ba" strokeOpacity=".09" />
          </pattern>
        </defs>
        <path d="M0 0h640v380H0z" fill="url(#ismh-grid)" />
        <text x="36" y="48" fill="#cbd0d2" className="art-small">
          ISMH / A CONNECTED CONVERSATION
        </text>
        {[102, 190, 278].map((y, i) => (
          <g key={y}>
            <rect
              x="65"
              y={y - 22}
              width="124"
              height="44"
              rx="3"
              stroke="#889695"
            />
            <text
              x="127"
              y={y + 4}
              textAnchor="middle"
              className="art-mono"
              fill="#d7dddd"
            >
              {["WHATSAPP", "INSTAGRAM", "MESSENGER"][i]}
            </text>
            <path
              d={`M189 ${y}h40q18 0 18 ${y === 102 ? 18 : y === 278 ? -18 : 0}V190h33`}
              stroke="#8d9e97"
            />
          </g>
        ))}
        <rect x="280" y="145" width="98" height="90" rx="3" stroke="#d1ac87" />
        <path
          d="m310 180 19-11 19 11v22l-19 11-19-11v-22Zm0 0 19 11m19-11-19 11v22m0-44v22"
          stroke="#d1ac87"
        />
        <path d="M378 190h66m-8-5 8 5-8 5" stroke="#d1ac87" />
        <rect x="448" y="166" width="128" height="48" rx="3" stroke="#889695" />
        <text
          x="512"
          y="194"
          textAnchor="middle"
          fill="#d7dddd"
          className="art-mono"
        >
          AI ↔ HUMAN
        </text>
        <path d="M329 235v49" stroke="#d1ac87" strokeDasharray="3 5" />
        <text
          x="329"
          y="310"
          textAnchor="middle"
          fill="#d1ac87"
          className="art-mono"
        >
          CONTEXT, RETRIEVED.
        </text>
      </svg>
    );
  if (kind === "flood")
    return (
      <svg
        viewBox="0 0 640 380"
        fill="none"
        role="img"
        aria-label="Concept illustration: a river over a gridded landscape represents flood segmentation"
      >
        <path fill="#dce0d7" d="M0 0h640v380H0z" />
        {Array.from({ length: 13 }, (_, i) => (
          <path
            key={i}
            d={`M${i * 65 - 130} 0 0 ${i * 48 + 20}M${i * 65 + 40} 0 640 ${i * 48 - 100}`}
            stroke="#bbc4b4"
            strokeWidth=".8"
          />
        ))}
        {Array.from({ length: 10 }, (_, i) => (
          <path
            key={i}
            d={`M-20 ${90 + i * 20}Q170 ${-60 + i * 21} 310 ${170 + i * 10}T680 ${100 + i * 23}`}
            stroke="#9aab91"
            strokeWidth="1"
            opacity=".45"
          />
        ))}
        <path
          d="M280-40c-78 106 79 121 6 208S161 279 220 420"
          stroke="#849eaa"
          strokeWidth="83"
          opacity=".22"
        />
        <path
          d="M280-40c-78 106 79 121 6 208S161 279 220 420"
          stroke="#6c8e9f"
          strokeWidth="42"
          opacity=".5"
        />
        <path
          d="M280-40c-78 106 79 121 6 208S161 279 220 420"
          stroke="#4d7186"
          strokeWidth="16"
        />
        <path
          d="M165 112v-18h18m196 0h18v18m0 146v18h-18m-196 0h-18v-18"
          stroke="#344f5c"
          strokeWidth="1.5"
        />
        <path d="M397 185h65" stroke="#344f5c" strokeDasharray="3 4" />
        <text x="467" y="182" fill="#344f5c" className="art-mono">
          WATER
        </text>
        <text x="467" y="199" fill="#344f5c" className="art-small">
          SEGMENTED
        </text>
        <text x="36" y="48" fill="#344f5c" className="art-small">
          A DIFFERENT WAY TO READ THE EARTH.
        </text>
        <text x="450" y="340" fill="#344f5c" className="art-small">
          IMAGERY → INSIGHT
        </text>
      </svg>
    );
  return (
    <svg
      viewBox="0 0 640 380"
      fill="none"
      role="img"
      aria-label="Concept illustration: mathematical curves unfold from a shared origin"
    >
      <defs>
        <pattern
          id="manim-grid"
          width="25"
          height="25"
          patternUnits="userSpaceOnUse"
        >
          <path d="M25 0H0v25" stroke="#9f6a52" strokeOpacity=".1" />
        </pattern>
      </defs>
      <path fill="url(#manim-grid)" d="M0 0h640v380H0z" />
      <text x="36" y="48" fill="#874d35" className="art-small">
        A LITTLE CODE. A DIFFERENT PERSPECTIVE.
      </text>
      <path d="M70 285h490M120 70v240" stroke="#ad7c65" strokeOpacity=".4" />
      {Array.from({ length: 16 }, (_, n) => (
        <path
          key={n}
          d={Array.from({ length: 130 }, (_, i) => {
            const x = i / 129;
            return `${i ? "L" : "M"}${120 + x * 380},${285 - 170 * Math.sin(x * Math.PI * (0.4 + n * 0.055)) * x ** 0.25}`;
          }).join(" ")}
          stroke="#b54f2b"
          strokeWidth="1.2"
          opacity={0.3 + n * 0.04}
        />
      ))}
      <circle cx="120" cy="285" r="4" fill="#b54f2b" />
      <text
        x="290"
        y="93"
        fill="#874d35"
        fontFamily="Georgia, serif"
        fontSize="23"
        fontStyle="italic"
      >
        What does an idea look like?
      </text>
      <text x="463" y="340" fill="#874d35" className="art-small">
        MATHS, MADE VISIBLE.
      </text>
    </svg>
  );
}
